export default "__VITE_ASSET__1e6028aa__"